import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-select')
    const options = [
      {
        label: 'Podstawowy',
        value: 'primary'
      },
      {
        label: 'Drugorzędny',
        value: 'secondary'
      }
    ]
    child.children = options.map((option, i) => ({
      component: 'el-option',
      attrs: {
        label: option.label,
        value: option.value,
        key: option.key || i
      }
    }))

    this.children = [child]
  }
}
